import { useMemo } from 'react';
import { GetSponsorSessions, GetSponsorSessionsResponse } from '../api/dtos';

import useSWR, { SWRConfiguration, SWRResponse, mutate } from 'swr';
import { client } from '../api/client';
import { JsonServiceClient } from '@servicestack/client';
import { useGet } from '@ngt/forms';


const getData = (response?: SWRResponse<GetSponsorSessionsResponse, GetSponsorSessionsResponse>) => response?.data?.sessions;
const getError = (response?: SWRResponse<GetSponsorSessionsResponse, GetSponsorSessionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useSponsorSessions = (
    configuration: SWRConfiguration = {
}) => {

    const request = useMemo(() => {
        return () => {
            return new GetSponsorSessions();
        }
    }, []);

    return useGet(request, { getData, getError }, configuration)
}

export default useSponsorSessions;